/* @flow */
import Loadable from "react-loadable";
import BrandSpinner from "../Spinners/BrandSpinner/index";

export default Loadable({
  loader: () => import("./ClickhouseChart"),
  delay: 2000,
  LoadingComponent: BrandSpinner
});



// WEBPACK FOOTER //
// ./src/components/Chart/index.js